"use client";

import React from "react";
import { Typography } from "@/components/ui/typography";
import { useCities } from "@/lib/react-query/queries/references/use-cities";
import type { City } from "@/types/city";

interface AccommodationCountTextProps {
  stateCitySlug: string;
  totalCount: number;
  fallbackCityName?: string;
  variant?: "bodyMRegular" | "captionRegular";
  className?: string;
  color?: "default" | "black300" | "black" | "error";
}

export function AccommodationCountText({
  stateCitySlug,
  totalCount,
  fallbackCityName,
  variant = "bodyMRegular",
  className,
  color,
}: AccommodationCountTextProps) {
  const { data: citiesResponse } = useCities();
  const cities = citiesResponse?.data || [];

  // Find city by slug
  const city = React.useMemo(() => {
    if (!stateCitySlug) return null;
    return cities.find((c: City) => c.slug === stateCitySlug);
  }, [stateCitySlug, cities]);

  // Get display name - prefer API city name, then fallback, then slug
  const displayName = city?.name || fallbackCityName || stateCitySlug;

  return (
    <Typography variant={variant} className={className} color={color}>
      اقامتگاه‌های {displayName}{" "}
      <Typography variant="bodySRegular" as="span">
        ({totalCount} اقامتگاه)
      </Typography>
    </Typography>
  );
}
